import StoniTenis from './StoniTenis'

const Pikado = () => <StoniTenis calculatorType='Pikado' />

export default Pikado
